import signedFetch from '../../util/signedFetch.js';

export default ({ orgId, assignments }) => {
  const url = `${__API_BASE__}/ngs/org/${orgId}/assignments`;
  return signedFetch('ngsDeleteAssignments', url, 'DELETE', { assignments });
};
